/**
 * Created by Aleksandr on 02.08.2024
 */

const CompleteLocationComponent = function (unit, options, completeLocationId) {
    UnitComponent.call(this, unit);

    if (Homefix.currentHomefix && Homefix.currentHomefix.location.locationId === completeLocationId) {
        Homefix.currentHomefix.location.complete();
    }
};

CompleteLocationComponent.prototype = Object.create(UnitComponent.prototype);
CompleteLocationComponent.prototype.constructor = CompleteLocationComponent;
